export default "__VITE_ASSET__Dai05kSD__"